import { render, staticRenderFns } from "./NewCommentBox.vue?vue&type=template&id=fd0fc8c0&scoped=true&"
import script from "./NewCommentBox.vue?vue&type=script&lang=js&"
export * from "./NewCommentBox.vue?vue&type=script&lang=js&"
import style0 from "./NewCommentBox.vue?vue&type=style&index=0&id=fd0fc8c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0fc8c0",
  null
  
)

export default component.exports